import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-m-0 p-p-2" }
const _hoisted_2 = {
  key: 0,
  class: "p-ml-2 kn-truncated priority-items-container"
}
const _hoisted_3 = { class: "p-d-flex p-flex-row" }
const _hoisted_4 = { class: "p-mr-2 kn-flex" }
const _hoisted_5 = {
  key: 0,
  class: "p-ml-2 kn-truncated priority-items-container"
}
const _hoisted_6 = { class: "p-ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.perspective)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "perspective-card"
      }, {
        header: _withCtx(() => [
          _createVNode("div", {
            class: ["perspective-header p-d-flex p-flex-row p-ai-center", _ctx.toolbarBorderClass]
          }, [
            _createVNode("h2", _hoisted_1, _toDisplayString(_ctx.perspective.name), 1),
            _withDirectives(_createVNode("span", { class: "perspective-target-icon kn-cursor-pointer" }, _toDisplayString(_ctx.getTargetIconLetter(_ctx.perspective.criterion?.valueCd)), 513), [
              [_directive_tooltip, _ctx.getSelectedCriteriaTooltip(_ctx.perspective.criterion?.valueCd)]
            ]),
            (_ctx.perspective.criterion?.valueCd !== 'MAJORITY')
              ? (_openBlock(), _createBlock("div", _hoisted_2, _toDisplayString('(' + _ctx.getPriorityItems(_ctx.perspective) + ')'), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        content: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.perspective.targets, (target, index) => {
            return (_openBlock(), _createBlock("div", {
              class: ["target-row p-d-flex p-flex-row p-ai-center p-p-3 p-my-2", { 'perspective-target-container': index !== _ctx.perspective.targets.length - 1 }],
              key: index
            }, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, _toDisplayString(target.name), 1),
                _withDirectives(_createVNode("span", { class: "p-ml-auto perspective-target-icon kn-cursor-pointer" }, _toDisplayString(_ctx.getTargetIconLetter(target.criterion?.valueCd)), 513), [
                  [_directive_tooltip, _ctx.getSelectedCriteriaTooltip(target.criterion?.valueCd)]
                ]),
                (target.criterion?.valueCd !== 'MAJORITY')
                  ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString('(' + _ctx.getPriorityItems(target) + ')'), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("i", {
                  class: ["fas fa-square fa-2xl p-mr-2", _ctx.getTargetStatusIconColor(target)]
                }, null, 2)
              ])
            ], 2))
          }), 128))
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}